export default __webpack_public_path__ + "static/media/o-700.92425c62.woff2";